// The Penyedia menus (Dashboard, Pantau Paket, Alur Kerja): the official
// portals, the watchlist labels, and the paket stage labels the dashboard
// groups by (the four Penyedia stages plus the earlier stage names, so a
// project from before the change still reads right).
import type { WatchItem, WatchStatus } from "../api";

export interface Portal {
  name: string;
  url: string;
  desc: string;
}

/** The official portals a Penyedia searches; Pluto never fetches from them. */
export const PORTALS: Portal[] = [
  // SiRUP moved to sirup.inaproc.id; the old sirup.lkpp.go.id no longer
  // resolves at all, so the card linked nowhere. Deep-link to Cari Paket.
  { name: "SiRUP", url: "https://sirup.inaproc.id/sirup/caripaketctr/index", desc: "Rencana Umum Pengadaan: peluang awal, belum tentu sudah tender." },
  { name: "SPSE", url: "https://spse.inaproc.id/", desc: "Paket tayang: tender, seleksi, dan non-tender di portal resmi." },
  { name: "Bantuan INAPROC", url: "https://bantuan.inaproc.id/hc/id-id", desc: "Bantuan akun, transaksi, dan panduan sistem untuk Penyedia." },
  { name: "E-Proc LKPP", url: "https://eproc.lkpp.go.id/aplikasi/", desc: "Direktori aplikasi PBJ: SiRUP, SPSE, dan katalog elektronik." },
];

export const WATCH_STATUS_LABEL: Record<WatchStatus, string> = {
  dipantau: "Dipantau",
  diminati: "Diminati",
  diabaikan: "Diabaikan",
};

export const WATCH_STATUS_ORDER: WatchStatus[] = ["dipantau", "diminati", "diabaikan"];

export function watchTone(status: WatchStatus): "neutral" | "info" | "success" {
  return status === "diminati" ? "success" : status === "dipantau" ? "info" : "neutral";
}

/** Metode pemilihan suggestions (free text is allowed). */
export const METODE_OPTIONS = [
  "Tender",
  "Tender Cepat",
  "Seleksi",
  "Pengadaan Langsung",
  "Penunjukan Langsung",
  "E-purchasing",
  "Dikecualikan",
];

export const JENIS_OPTIONS = ["Barang", "Pekerjaan Konstruksi", "Jasa Konsultansi", "Jasa Lainnya", "Terintegrasi"];

/** An opportunity still in play: not ignored and not yet a project. */
export function isActiveOpportunity(item: Pick<WatchItem, "status" | "projectId">): boolean {
  return item.status !== "diabaikan" && !item.projectId;
}

/** Labels of a paket project's stage, the current four and the earlier names. */
export const PAKET_STAGE_LABEL: Record<string, string> = {
  persiapan_pemilihan: "Persiapan Dokumen Penawaran",
  pelaksanaan_pemilihan: "Pelaksanaan Pemilihan",
  pelaksanaan_kontrak: "Pelaksanaan Kontrak",
  serah_terima: "Serah Terima",
  selesai: "Selesai",
  ditutup: "Ditutup",
  minat: "Minat",
  tender: "Tender",
  hasil: "Hasil",
  pelaksanaan: "Pelaksanaan",
};

/** The order the dashboard lists stages in; unknown stages go last. */
export const PAKET_STAGE_ORDER = [
  "persiapan_pemilihan",
  "minat",
  "pelaksanaan_pemilihan",
  "tender",
  "hasil",
  "pelaksanaan_kontrak",
  "pelaksanaan",
  "serah_terima",
  "selesai",
  "ditutup",
];

/** End statuses: a paket there is no longer active. */
export const PAKET_END_STAGES = ["selesai", "ditutup"];

export function stageLabel(stage: string): string {
  return PAKET_STAGE_LABEL[stage] ?? stage.replace(/_/g, " ");
}
